import React from 'react';
import formatTime from 'mn-utils/formatTime';

import TableItemWithSubtitle from '../../TableItemWithSubtitle';
import merchantCtor from './merchantCtor';

const displayDateTitle = ({date}) => date ? formatTime.getRFC3339(date) : '';
const displayDateData = ({date}) => {
  if (!date) return '';

  return (
    <TableItemWithSubtitle
      item={formatTime(date, '{dd} {mmm}, {yyyy}')}
      subItem={formatTime(date, '{hh}:{MM}:{ss} {TT}')}
    />
  )
};

const formatDetailedDate = ({date}) => formatTime(date, '{dddd} {mmmm} {dd}, {yyyy} {hh}:{MM} {TT}');

const basicProps = {titleHandler: displayDateTitle, hasCustomData: true}

const dateTimeProps = {...basicProps, dataHandler: displayDateData};
const dateDetailedProps = {...basicProps, dataHandler: formatDetailedDate};

// const displayDateTimeAdmin = adminCtor(dateTimeProps);
const displayDateTimeMerchant = merchantCtor(dateTimeProps);

// const displayDateDetailedAdmin = adminCtor(dateDetailedProps);
const displayDateDetailedMerchant = merchantCtor(dateDetailedProps);

module.exports = {
  // displayDateTimeAdmin,
  // displayDateDetailedAdmin,

  displayDateTimeMerchant,
  displayDateDetailedMerchant
};
